import { faVault } from '@fortawesome/pro-regular-svg-icons'
import { Box, Flex, Text, Progress } from '@mantine/core'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

import { useQueryGetBookingById } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import {
  BadgeBookingPaymentDepositStatus,
  Icon,
  TextCurrency,
} from '@flecto/ui'

export const DepositOverviewCard = () => {
  const router = useRouter()
  const id = String(router.query?.id)

  const { t: tBooking } = useTranslation('saas', { keyPrefix: 'booking' })
  const { t: tCreateBooking } = useTranslation('saas', {
    keyPrefix: 'create-booking-payments',
  })

  const { data: booking } = useQueryGetBookingById({ bookingId: id })

  const depositCents = booking?.meta?.deposit_cents ?? 0
  const depositMissingCents = booking?.meta?.deposit_missing_collect_cents ?? 0

  const totalDepositToReceive =
    booking?.meta?.deposit_missing_collect_cents ?? 0
  const depositOverpaidAmount = booking?.meta?.deposit_missing_return_cents ?? 0
  const isDepositOverpaid =
    booking?.meta?.payment_deposit_status === 'payment_deposit_to_return' ||
    Number(booking?.meta?.deposit_missing_return_cents) > 0

  const depositPercent = useMemo(() => {
    const valueInput = isDepositOverpaid ? 0 : depositMissingCents

    return ((depositCents - valueInput) * 100) / depositCents
  }, [depositCents, depositMissingCents, isDepositOverpaid])

  return (
    <Box mt='lg'>
      <Flex gap='sm' wrap='nowrap' align='center' justify='space-between'>
        <Flex align='center' gap='sm'>
          <Icon icon={faVault} size='sm' withCircleBackground />
          <Text fw={500}>
            {tBooking('create-booking.booking_payments.deposit')}
          </Text>
        </Flex>
        <BadgeBookingPaymentDepositStatus booking={booking} />
      </Flex>
      <Flex mt='md' align='flex-start' direction='column'>
        <Flex align='baseline' gap='xs'>
          <TextCurrency
            fw={500}
            cents={
              isDepositOverpaid ? depositOverpaidAmount : totalDepositToReceive
            }
          />
          <Text color='dimmed' size='sm'>
            {isDepositOverpaid
              ? tCreateBooking('amount_to_return')
              : tCreateBooking('amount_to_receive')}
          </Text>
        </Flex>
        <Progress
          mt='xs'
          w='100%'
          color={isDepositOverpaid ? 'red' : 'green'}
          value={depositPercent}
        />
      </Flex>
    </Box>
  )
}

export default DepositOverviewCard
